import React from 'react';
import { Box, Grid, Link, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import pdfIcon from '../../assets/images/AdobePdfIcon.svg';
import docIcon from '../../assets/images/icons/Doc_Icon.svg';
import { openPDFLink } from '../../Utils';

export default function PdfLinks({
    pdfLink,
    fundName,
    showPdfIcon,
    fundId,
    linkId,
    noIcon,
    pdfTitle,
    singleCol,
}) {

    const getAdjustedIcon = showPdfIcon ? pdfIcon : docIcon;
    const getLinkId = linkId ?? `${fundName.replaceAll(' ','-')}-pdf-link`
    return (
        <Grid
            item
            cols={12}
            md={singleCol ? 12 : 6}
            lg={singleCol ? 7 : 6}
            id={getLinkId}
        >
            <Link
                href={pdfLink}
                target="_blank"
                onClick={openPDFLink(pdfLink)}>
                <Typography
                    type="body" loose scale={100}
                    component="span"
                >

                    <Box id={fundId} sx={{ display: 'flex', alignItems: 'center', gap: '4rem', paddingBottom: !noIcon ? '16px' : '0' }}>
                        {!noIcon && (
                            <Box id="pdf-icon-container">
                                <img src={getAdjustedIcon} alt="pdf" id='something' />
                            </Box>
                        )}
                        {fundName} {pdfTitle && '(PDF)'}
                    </Box>
                </Typography>
            </Link>
        </Grid>
    );
}
